module.exports = "/_next/static/images/img_list-3-781705a33199e9297cdb49249d84b604.webp";